module.exports = __webpack_public_path__ + "static/media/sdgLogo.8240c792.png";